import { useTranslation } from "react-i18next";
import { Layout, TableColumnsType, TableProps, Tabs } from "antd";
import PageHeader from "../../../components/page-header/PageHeader";
import FilterTable from "./component/filter-table/FilterTable";
import FormFilter from "./component/filter-group/FormFilter";
import { ChangeEvent, KeyboardEvent, useEffect, useState } from "react";
import { DataType } from "./constants/data";
import { formatDateToIsoStringHHssTypeDateTime } from "../../../utils/converDate";
import { FormInstance, TabsProps } from "antd/lib";
import { isEmpty } from "lodash";
import { moocPolicyGetHistoryByFilter } from "../../../service/clause";
import { useNavigate } from "react-router-dom";
import TableData from "../../../components/table-data/TableData";
import { globalStore } from "../../../stores/stores";
import "./clause-history.scss";

const imgPath = "/images/";

const ClauseHistory = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { reload } = globalStore();
  const [tab, setTab] = useState("1");
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [statusOrder, setStatusOrder] = useState<string>("");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("");
  const [dataClauseHistory, setDataClauseHistory] = useState<any>([]);

  const [filterData, setFilterData] = useState<any>({
    keyword: null,
    action: null,
    createdDateFrom: null,
    createdDateTo: null,
  });

  const dataColumns: TableColumnsType<DataType> = [
    {
      title: "STT",
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 10,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Tên", "Tên"),
      dataIndex: "moocPolicyName",
      key: "moocPolicyName",
      width: 60,
      className: "table-clause-history",
    },
    {
      title: t("Thao tác", "Thao tác"),
      dataIndex: "name",
      key: "name",
      width: 20,
    },
    {
      title: t("Ngày cập nhật", "Ngày cập nhật"),
      dataIndex: "created_date",
      key: "created_date",
      width: 30,
      sorter: true,
      render: (_: any, record, index: number) => {
        return record.createdDate ? formatDateToIsoStringHHssTypeDateTime(record.createdDate) : null;
      },
    },
    {
      title: t("Người thao tác", "Người thao tác"),
      dataIndex: "createdByName",
      key: "createdByName",
      width: 30,
    },
  ];

  const itemsTab: TabsProps["items"] = [
    {
      key: "1",
      label: t("Chính sách bảo mật", "Chính sách bảo mật"),
    },
    {
      key: "2",
      label: t("Điều khoản dịch vụ", "Điều khoản dịch vụ"),
    },
  ];

  // Tabs
  const onTabClick = (key: string) => {
    setFieldSortOrder("created_date");
    setStatusOrder("desc");
    setTab(key);
  };

  // Filter Search
  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const clearFilter = (form: FormInstance) => {
    form.resetFields();
    setFilterData({
      action: null,
      createdDateFrom: null,
      createdDateTo: null,
    });
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchValue(value);
    if (value.length === 0) {
      setSearchValue("");
    }
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      setPageNumber(1);
      getAllClauseHistory();
    }
  };

  const handleSubmitSearch = () => {
    setPageNumber(1);
    getAllClauseHistory();
  };

  const handleFinish = (values: any) => {
    setPageNumber(1);
    setFilterData({
      ...filterData,
      action: values?.action,
      createdDateFrom: values?.time
        ? (values?.time[0]).add(1, "day").toISOString()
        : null,
      createdDateTo: values?.time
        ? (values?.time[1]).add(1, "day").toISOString()
        : null,
    });
  };

  // Get data clause history
  const getAllClauseHistory = (data?: any) => {
    setLoading(true);
    const dataReq = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue,
      action: filterData.action,
      createdDateFrom: filterData.createdDateFrom
        ? filterData.createdDateFrom
        : null,
      createdDateTo: filterData.createdDateTo ? filterData.createdDateTo : null,
      type: Number(tab),
      enterpriseId: localStorage.getItem("schoolManagement"),
      sort:
        isEmpty(fieldSortOrder) || isEmpty(statusOrder)
          ? ["created_date, desc"]
          : [`${fieldSortOrder},${statusOrder}`],
    };
    moocPolicyGetHistoryByFilter(dataReq)
      .then((res) => {
        setDataClauseHistory(res.data.data.content);
        setTotalRecords(res.data.data.totalElements);
        setTimeout(() => {
          setLoading(false);
        }, 300);
      })
      .catch((err) => {
        if (err.response?.status === 403) {
          navigate("/error/403");
        } else {
          console.error(err);
        }
        setLoading(false);
      });
  };

  // Sort
  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
        ? "desc"
        : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  // useEffect
  useEffect(() => {
    getAllClauseHistory();
  }, [pageNumber, pageSize, filterData, statusOrder, tab, reload]);

  return (
    <Layout className="page-header-group">
      <div
        className={`page-header-group--layout ${
          showFilter ? "open-filter" : ""
        }`}
      >
        <div className="table-header--wrapper">
          <div className="table-header--left">
            <PageHeader
              title={t("Lịch sử điều khoản và chính sách", "Lịch sử điều khoản và chính sách")}
              arrowLeft={imgPath + "arrowLeft.svg"}
            />
          </div>
          <FilterTable
            searchValue={searchValue}
            handleOpenFilter={handleOpenFilter}
            handleSubmitSearch={handleSubmitSearch}
            handleSearch={handleSearch}
            handleChangeInput={handleChangeInput}
          />
        </div>
        <FormFilter
          clearFilter={clearFilter}
          onFinish={handleFinish}
          showFilter={showFilter}
        />
      </div>

      <Tabs
        className="clause-tabs"
        defaultActiveKey="1"
        items={itemsTab}
        tabPosition={"top"}
        onTabClick={onTabClick}
      />

      <TableData
        dataTable={dataClauseHistory}
        dataColumns={dataColumns}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        pageNumber={pageNumber}
        pageSize={pageSize}
        pagination={true}
        scroll={{ x: 1500, y: 600 }}
        totalRecords={totalRecords}
        loadingTable={loading}
        handleTableChangeProps={handleTableChange}
      />
    </Layout>
  );
};

export default ClauseHistory;
